<template>
  <v-flex xs12 text-xs-center sm9 md6 lg4 xl3 mx-8>
  <!-- <v-flex class="padding-left"> -->
    <v-layout>
      <v-flex xs12>
        <v-flex xs12>
          <NewIcon :enable="item.is_new"></NewIcon>
        </v-flex>
        <v-flex xs12>
          <h1>{{ item.title || item.slug }}</h1>
        </v-flex>
        <v-flex>
          <RatingIcon :value="item.rating_eu" style="height: 18px;"></RatingIcon>
          <Duration :item="item.duration"></Duration>
        </v-flex>
        <v-flex xs12>
          <ProgramButtons
            :watching="watching"
            :item="item"
            @openVideo="$emit('openVideo', $event)"
            @openVideoFromTimestamp="$emit('openVideoFromTimestamp')"></ProgramButtons>
        </v-flex>
        <v-flex class="fixed-width text-xs-left hidden-xs-only">
          <ProgramDetails :item="item"></ProgramDetails>
        </v-flex>
<!--         <v-flex class="fixed-width hidden-sm-and-up">
          <ProgramButtons
          :watching="watching"
          :item="item"
          @openVideo="$emit('openVideo', $event)"
          @openVideoFromTimestamp="$emit('openVideoFromTimestamp')"></ProgramButtons>
        </v-flex> -->
      </v-flex>
    </v-layout>
    <!-- <v-flex xs12 class="hidden-sm-and-down">
      <ProgramDescription :description="item.description"></ProgramDescription>
    </v-flex> -->
  </v-flex>
</template>

<script>
import RatingIcon from '@/components/RatingIcon'
import NewIcon from '@/components/NewIcon'
import Duration from '@/components/Duration'
import ProgramDetails from '@/components/ProgramDetails'
import ProgramDescription from '@/components/ProgramDescription'
import ProgramButtons from '@/components/ProgramButtons'

export default {
  components: {
    RatingIcon,
    NewIcon,
    Duration,
    ProgramDetails,
    ProgramDescription,
    ProgramButtons
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    watching: {
      type: Object
    }
  }
}
</script>

<style scoped>
  .padding-left {
    padding-left: 20px;
  }
</style>
